import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProductDetailsResponseDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { RootStateType } from 'App/store';
import { useGetLanguage } from 'domains/Auth/hooks';
import { createGetProductById } from 'domains/Catalog/Products/productsSlice/productSelectors';

interface UseProductListItemInterface {
  product: ProductDetailsResponseDto;
  language: LanguagesType;
}

function useProductListItem(id: string): UseProductListItemInterface {
  const getProductById = useMemo(createGetProductById, []);
  const product = useSelector((state: RootStateType) =>
    getProductById(state, id),
  );
  const language = useGetLanguage();

  return { product, language };
}

export default useProductListItem;
